import type { AssociationIds } from "avvir";
import Avvir from "avvir";

import getScanDatasetsForProjectByFirebaseId from "../../../services/getters/scan_dataset_getters/get_scan_datasets_for_project_by_firebase_id";
import scanDatasetsForProjectLoaded, { ScanDatasetsForProjectLoadedEvent } from "../../../events/loaded/scan_datasets/scan_datasets_for_project_loaded";
import type { AvvirAsyncThunk } from "../../make_eventful_action";

const loadScanDatasetsForProject = ({ projectId }: AssociationIds): AvvirAsyncThunk<typeof getScanDatasetsForProjectByFirebaseId, ScanDatasetsForProjectLoadedEvent> => {
  return (dispatch, getState) => {
    const state = getState();
    return Avvir.api.scanDatasets.listScanDatasetsForProject({ projectId }, state.user).then(scanDatasets => {
      dispatch(scanDatasetsForProjectLoaded(projectId, scanDatasets));
      return getScanDatasetsForProjectByFirebaseId(getState(), { projectId });
    });
  };
};

export default loadScanDatasetsForProject;
